import main__img1 from '../assets/img/main__img1.jpg';
import main__img2 from '../assets/img/main__img2.jpg';
import robot_img from '../assets/img/robot-img.jpg';
import scratch__img1 from '../assets/img/scratch__img1.jpg';
import scratch__img2 from '../assets/img/scratch__img2.jpg';
import scratch__img3 from '../assets/img/scratch__img3.jpg';
import game__img1 from '../assets/img/games__img1.png';
import game__img2 from '../assets/img/games__img2.png';
import game__img3 from '../assets/img/games__img3.png';
import web__img1 from '../assets/img/web__img1.jpg';
import android__img1 from '../assets/img/android__img1.png';
import android__img2 from '../assets/img/android__img2.png';
import android__img3 from '../assets/img/android__img3.jpg';
import instagram_img from '../assets/img/instagram_img.svg';
import facebook_img from '../assets/img/facebook_img.svg';
import youtube_img from '../assets/img/youtube_img.svg';
import detail__img1 from '../assets/img/detail-img1.png';
import detail__img2 from '../assets/img/detail-img2.png';
import detail__img3 from '../assets/img/detail-img3.png';
import detail__img4 from '../assets/img/detail-img4.png';
import detail__img5 from '../assets/img/detail-img5.png';
import detail__img6 from '../assets/img/detail-img6.png';
import detail__img7 from '../assets/img/detail-img7.png';
import detail__img8 from '../assets/img/detail-img8.png';
import detail__img9 from '../assets/img/detail-img1.jpg';
import detail__img10 from '../assets/img/detail-img2.jpg';
import teacher1 from '../assets/img/teacher-img1.png';
import teacher2 from '../assets/img/teacher-img2.png';
import teacher3 from '../assets/img/teacher-img3.png';
import teacher4 from '../assets/img/teacher-img4.png';
import teacher5 from '../assets/img/teacher-img5.png';
import teacher6 from '../assets/img/teacher-img6.png';
import web__img_data1 from '../assets/img/web__img-data1.jpg';
import web__img_data2 from '../assets/img/web__img-data2.jpg';


export const images = {
    main__img1,
    main__img2,
    robot_img,
    scratch__img1,
    scratch__img2,
    scratch__img3,
    game__img1,
    game__img2,
    game__img3,
    web__img1,
    android__img1,
    android__img2,
    android__img3,
    instagram_img,
    facebook_img,
    youtube_img,
    detail__img1,
    detail__img2,
    detail__img3,
    detail__img4,
    detail__img5,
    detail__img6,
    detail__img7,
    detail__img8,
    detail__img9,
    detail__img10,
    teacher1,
    teacher2,
    teacher3,
    teacher4,
    teacher5,
    teacher6,
    web__img_data1,
    web__img_data2,
}

export default images;